import { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'

export function captureServerError(error: unknown) {
  if (error instanceof AxiosError) {
    const status = error.response?.status

    if ((typeof status === 'number' && status >= 500) || !error.response) {
      Sentry.withScope((scope) => {
        scope.setTag('error_kind', 'server_request')

        if (typeof status === 'number') {
          scope.setTag('http_status', String(status))
        }

        if (error.config?.method) {
          scope.setTag('http_method', error.config.method.toUpperCase())
        }

        if (error.config?.url) {
          scope.setContext('request', {
            url: error.config.url,
            baseURL: error.config.baseURL,
          })
        }

        Sentry.captureException(error)
      })
    }

    return
  }

  if (error instanceof Error) {
    Sentry.captureException(error)
  }
}
